// @flow
import React, { Fragment } from "react";
import "./styles.css";
import MainNavigation from "../main-navigation";
import * as sessionActionCreators from "../../action-creators/session-actions";
import "@mdi/font/css/materialdesignicons.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { environment } from "../../data/firebase-config";

type PropsType = {
    children: any,
    user: Object,
    modals: Object,
    screenName: string,
    actions: { [string]: any => void }
};

const MyComponent = ({ actions, user, modals, children }: PropsType): React$Element<any> => {

    const { displayName, email, photoURL } = user;
    // eslint-disable-next-line no-alert
    const logout = () => (window.confirm("Are you sure you want to logout?") && actions.logout());

    return (
        <Fragment>
            <div className={ "layout--status-bar" }>
                <span className={ "layout--status-bar-environment" }>{environment}</span>
                <span className={ "layout--status-bar-wrapper" }>
                    <span className={ "layout--status-bar-user" }>
                        <span className={ "layout--status-bar-avatar" } style={ { backgroundImage: `url("${photoURL}")` } }/>

                    </span>

                    <span className={ "layout--status-bar-screen-name" }>{displayName || email}</span>
                    <span className={ "layout--status-bar-logout" }>
                        <button onClick={ logout } title={ "log-out" }>
                            <i className={ "mdi mdi-logout" }/>
                        </button>
                    </span>
                </span>
            </div>
            <div className="layout--main">
                {children}
            </div>
            <MainNavigation isMenuVisible={ modals.MENU_PANEL }/>
        </Fragment>
    );
};


const mapStateToProps = (state: Object): Object => {
    const user = (state.users || { data: {} }).data[state.session.user.uid] || { photoURL: state.session.user.photoURL };
    const modals = state.modals.data;
    return ({ user, modals });
};

const mapDispatchToProps = (dispatch): Object => ({
    actions: bindActionCreators(sessionActionCreators, dispatch)
});

export const Layout = connect(mapStateToProps, mapDispatchToProps)(MyComponent);

